/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PopoverContentHover/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import Children from 'Simple/Children'
import FloatingPortal from 'DesignSystem/FloatingPortal/react'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function PopoverContentHover({
  children,
  viewPath = "/DesignSystem/Popover/PopoverContentHover",
  isHoverOpen,
  contentRef,
  width = "100%",
  cursor,
  top,
  left,
  closePopover
  
}) {
  return (<React.Fragment
>
<FloatingPortal
  viewPath={`${viewPath}/FloatingPortal`}
>
{childProps => (
<fromFlow.When is={isHoverOpen}>
<div
  data-testid="PopoverContentHover.Vertical"
  data-view-path={viewPath}
 ref={contentRef}
 style={{'--w-1-Z2cju7W': typeof width === 'number' ? `${width}px` : width,'--c-2-Z2cju7W': cursor,'--t-3-Z2cju7W': typeof top === 'number' ? `${top}px` : top,'--l-4-Z2cju7W': typeof left === 'number' ? `${left}px` : left}}
 className={`views-block ${styles.Vertical}`}
>
<Children
  viewPath={`${viewPath}/Children`}
 closePopover={closePopover}
>
{children}
</Children>
</div>
</fromFlow.When>
)}
</FloatingPortal>
</React.Fragment>)
}